import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-508da524"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "SelectWarehouse"
};
var _hoisted_2 = {
  class: "top-fixed"
};
var _hoisted_3 = {
  class: "search-box"
};
var _hoisted_4 = {
  class: "date-box"
};
var _hoisted_5 = {
  class: "mr-1"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "mr-1"
  }, "至", -1);
});
var _hoisted_7 = {
  class: "mr-1"
};
var _hoisted_8 = {
  class: "tabs"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_11 = {
  class: "pt-2 list"
};
var _hoisted_12 = {
  key: 1,
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_search = _resolveComponent("van-search");
  var _component_release_item = _resolveComponent("release-item");
  var _component_van_cell = _resolveComponent("van-cell");
  var _component_van_cell_group = _resolveComponent("van-cell-group");
  var _component_van_list = _resolveComponent("van-list");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_van_calendar = _resolveComponent("van-calendar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_search, {
    modelValue: _ctx.params.stone_name,
    "onUpdate:modelValue": [_cache[0] || (_cache[0] = function ($event) {
      return _ctx.params.stone_name = $event;
    }), _ctx.onSearch],
    placeholder: "物料搜索",
    shape: "round",
    background: "#ffffff"
  }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "date flex align-center",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.showCalendar && _ctx.showCalendar.apply(_ctx, arguments);
    })
  }, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatDate(_ctx.params.start_time)), 1), _hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.params.end_time)), 1)])]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["feedingTab", {
        active: _ctx.tabActive === index
      }]),
      key: item.name,
      onClick: function onClick($event) {
        return _ctx.tabClick(item, index);
      }
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _hoisted_10], 10, _hoisted_9);
  }), 128))])]), _createElementVNode("div", _hoisted_11, [_ctx.list.length ? (_openBlock(), _createBlock(_component_van_list, {
    key: 0,
    loading: _ctx.loading,
    "onUpdate:loading": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.loading = $event;
    }),
    finished: _ctx.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onLoad
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
            return _openBlock(), _createBlock(_component_van_cell, {
              clickable: "",
              key: item.release_no
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_release_item, {
                  item: item,
                  index: index,
                  oaToken: _ctx.oaToken
                }, null, 8, ["item", "index", "oaToken"])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true), !_ctx.list.length && _ctx.finished ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_c_no_data)])) : _createCommentVNode("", true)]), _ctx.show ? (_openBlock(), _createBlock(_component_van_calendar, {
    key: 0,
    color: "#4372F6",
    show: _ctx.show,
    "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.show = $event;
    }),
    type: "range",
    "max-date": _ctx.maxDate,
    "min-date": _ctx.minDate,
    onConfirm: _ctx.confirmDate
  }, null, 8, ["show", "max-date", "min-date", "onConfirm"])) : _createCommentVNode("", true)]);
}